import { Box, Card } from '@mui/material';
import {
    ShowClasses,
    ShowProps,
    Title,
    useResourceDefinition,
    useShowContext,
} from 'react-admin';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ShowActions from './ShowActions';
import { mergeSx } from '../../../utils/material-ui';
import { ReactNode } from 'react';

export const ShowView = (props: ShowViewProps & { extraActions?: ReactNode }) => {
    const {
        actions,
        aside,
        children,
        className,
        extraActions,
        component: Content = Card,
        emptyWhileLoading = false,
        title,
        ...rest
    } = props;

    const { resource, defaultTitle, record } = useShowContext(props);
    const { hasEdit } = useResourceDefinition(props);

    const finalActions =
        typeof actions === 'undefined' ? (
            <ShowActions hasEdit={hasEdit} extraActions={extraActions} />
        ) : (
            actions
        );

    if (!children || (!record && emptyWhileLoading)) {
        return null;
    }

    return (
        <Box
            className={clsx('show-page', className)}
            /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
            // @ts-ignore
            {...sanitizeRestProps(rest)}
            sx={[
                {
                    '.MuiToolbar-root': {
                        background: 'none',
                    },
                },
                ...mergeSx(rest.sx),
            ]}
        >
            {finalActions !== false && finalActions}
            <Title
                title={title}
                defaultTitle={defaultTitle}
                preferenceKey={`${resource}.show.title`}
            />
            <div
                className={clsx(ShowClasses.main, {
                    [ShowClasses.noActions]: !finalActions,
                })}
            >
                <Content className={ShowClasses.card} variant={'outlined'}>
                    {children}
                </Content>
                {aside}
            </div>
        </Box>
    );
};

export type ShowViewProps = ShowProps;

ShowView.propTypes = {
    actions: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
    children: PropTypes.node,
    className: PropTypes.string,
    emptyWhileLoading: PropTypes.bool,
    title: PropTypes.any,
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const sanitizeRestProps = ({
    defaultTitle = null,
    hasCreate = null,
    hasEdit = null,
    hasList = null,
    hasShow = null,
    history = null,
    id = null,
    isLoading = null,
    isFetching = null,
    location = null,
    match = null,
    options = null,
    refetch = null,
    permissions = null,
    ...rest
}) => rest;
/* eslint-enable @typescript-eslint/no-unused-vars */
